import FormComponents from "components/forms/FormComponents";
import { Icon, Modal } from "enums";
import manager from "managers/app";
import ModalContent from "modals/content/ModalContent";
import { RoulettesModalProps } from "modals/content/roulettes/types";
import ModalFooter from "modals/footer/ModalFooter";
import ModalHeader from "modals/header/ModalHeader";
import { Component } from "react";
import { connect } from "react-redux";
import t from "translations/translator";
import { AppState } from "types/app";
import "./RoulettesModal.css";

const mapStateToProps = (state:AppState):RoulettesModalProps.Redux => {
	return {
		lang: state.userInfo.options.lang,
		gameLang: state.userInfo.options.gameLang,
		roulettes: state.modal[Modal.ROULETTE],
	};
};

class RoulettesModal extends Component<RoulettesModalProps.Component> {
	render():JSX.Element{
		return (
			<div id={Modal.ROULETTE} className="modal-wrapper">
				<ModalHeader text="Roulettes" icon={Icon.DUTY} />
				<ModalContent>
					<div className="roulette-wrapper">
						{this.props.roulettes.map((roulette) => {
							return <div key={roulette} className="roulette-card">
								<h3 className="roulette-name">{t.t(roulette)}</h3>
							</div>;
						})}
					</div>
				</ModalContent>
				<ModalFooter>
					<FormComponents.Button text="Close" onClick={manager.modal.close} translate={true} />
				</ModalFooter>
			</div>
		);
	}
}
export default connect(mapStateToProps)(RoulettesModal);
